import styled from "styled-components";

export const TenantInformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    padding-right: 5px;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        width: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }
    
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
`;

export const TenantInformationHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 20px 20px;
    border-radius: 5px;
    background-color: #111111;
    color: #EFEFEF;
`;

export const TenantTitleBar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const TenantAvatar = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 200px;
    height: 200px;
    margin-right: 50px;
    border-radius: 5px;
    background-color: #FFFFFF;
`;

export const TenantText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const TenantName = styled.div`
    display: flex;
    align-items: top;
    justify-content: space-between;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 1px;
    padding-bottom: 10px;
`;

export const TenantNo = styled.div`
    display: flex;
    align-items: center;
    padding: 2px 0px;
`;

export const TenantAddress = styled.div`
    display: flex;
    align-items: center;
    padding: 2px 0px;
`;

export const TenantIndustry = styled.div`
    display: flex;
    align-items: center;
    padding: 2px 0px;
`;

export const TenantRemarks = styled.div`
    display: flex;
    align-items: center;
    padding: 2px 0px;
`;

export const TenantDate = styled.div`

`;

export const PrefixIconWrapper = styled.div`
    display: inline-block;
    margin-right: 10px;
`;

export const InlineBlock = styled.div`
    display: inline-block;
`;

export const EditInfoButton = styled.div`

`;

export const TenantStatisticsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    margin: 40px 0px 0px 0px;
    border: 1px solid #CCCCCC;
    border-radius: 3px;
    color: rgb(51, 51, 51);
`;

export const TenantStatistics = styled.div`
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 150px;
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
`;

export const StatisticsTitle = styled.div`
    flex: 1 1 auto;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: bold;
    margin: 5px 0px;
`;

export const StatisticsValue = styled.div`
    letter-spacing: 1px;
    margin: 5px 0px;
`;

export const StatisticsNumber = styled.div`
    display: inline-block;
    font-size: 24px;
    letter-spacing: 1px;
    padding: 0px 2px;
`;

export const StatisticsCharts = styled.div`
    flex: 0 0 auto;
    
    & .ant-progress {
        font-size: 0px;
        line-height: 1;
    }

    & .ant-progress-outer {
        font-size: 0px;
        line-height: 1;
    }

    & .ant-progress-inner {
        background-color: rgba(0, 0, 0, 0.2);
    }

    & .ant-progress-text {
        height: 0px;
        color: rgb(100, 200, 255);
        font-size: 12px;
        font-style: normal;
        overflow: visible;
        display: flex;
        align-items: center;
        flex: 0 0 auto;
    }
`;

export const TenantOperations = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    margin: 40px 0px;
    border: 1px solid #CCCCCC;
    border-radius: 3px;
    color: rgb(51, 51, 51);
`;

export const TenantOperation = styled.div`
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 150px;
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
`;

export const TenantOperationTitle = styled.div`
    flex: 1 1 auto;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: bold;
    margin: 5px 0px;
`;

export const TenantOperationDescription = styled.div`
    font-size: 12px;
    color: #666666;
`;

export const TenantOperationButtons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;

export const AdminPasswordWrapper = styled.div`
    text-align: center;
    padding: 40px 0px;
`;

export const AdminPasswordTitle = styled.div`
    font-size: 14px;
    padding: 10px 0px;
`;

export const AdminPassword = styled.div`
    font-size: 24px;
    font-weight: bold;
    padding: 10px 0px;
`;

export const AdminPasswordTips = styled.div`
    font-size: 12px;
    color: #666666;
    padding: 10px 0px;
`;